class TreeMapResultVM extends BaseResultVM {
    dataTable: [];
    field: TreeMapColumnInfo;
    groupField: TreeMapColumnInfo;
    metric: TreeMapColumnInfo;

    currencyCode: string;

    treeMapSettings: DevExpress.viz.dxTreeMap.Properties;
    treeMapComponent: DevExpress.viz.dxTreeMap;

    constructor(data) {
        super(data);

        this.dataTable = data.dataTable ?? [];
        this.field = data.field;
        this.groupField = data.groupField;
        this.metric = data.metric;

        this.currencyCode = data.currencyCode;
    }
}